import { useQuery } from "@tanstack/react-query"
import { IPoint } from "../../../../hooks/react-query/usePatrimonyChart";
import api from "../../../../services/api"

interface IStockHistoricalPotential {
  historicalPotential: {
    values: IPoint[]
    maxValue: number;
    minValue: number;
  }
}

export const useStockHistoricalPotential = (stock_id: string) => {
  const query = useQuery(['stock-historical-potential', stock_id], async () => {
    const response = await api.get<IStockHistoricalPotential>(`/stocks/get-stock-potential-values/${stock_id}`)

    return response.data
  })

  return query
}
